import React from 'react'
import { Col, Row } from 'reactstrap';
import 'animate.css';
import { HeaderPreviewInvoice } from './HeaderPreviewInvoice';
import { BodyConceptsPreviewInvoice } from './BodyConceptsPreviewInvoice';
import { FooterPreviewInvoice } from './FooterPreviewInvoice';
import { Dialog } from 'primereact/dialog';



export const ModalPreviewInvoice = (props) => {

    const { loadingPreview, showPreviewInvoice, handlePreviewInvoice, formInvoice, filterDateRanges, optionsDue, value_tax, listSettings, listBranches } = props;

    return (
        <Dialog
            visible={showPreviewInvoice}
            modal
            onHide={handlePreviewInvoice}
            headerStyle={{
                background: 'linear-gradient( #0d3b59)',
                color: 'white',
                fontWeight: 'bold',
                borderRadius: '12px 12px 0 0'
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            className='custom-dialog-preview-invoice'
        >
            <div className='container-global-zoom' >
                {
                    loadingPreview && (
                        <>
                            <Row>
                                <Col sm="12" md="12" lg="12" className='text-center'>
                                    <img alt='modal-preview' src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} className='fa-spin' style={{ width: "10%" }} />
                                </Col>
                                <Col sm="12" md="12" lg="12" className='text-center mt-1'>
                                    <p>Cargando ...</p>
                                </Col>
                            </Row>
                        </>
                    )
                }
                {
                    !loadingPreview && <HeaderPreviewInvoice
                        typeDocument="I"
                        dataInvoice={formInvoice}
                        listSettings={listSettings}
                        listBranches={listBranches}
                    />
                }
                {
                    !loadingPreview && <BodyConceptsPreviewInvoice
                        dataInvoice={formInvoice}
                        filterDateRanges={filterDateRanges}
                    />
                }
                {
                    !loadingPreview && <FooterPreviewInvoice
                        dataInvoice={formInvoice}
                        optionsDue={optionsDue}
                        value_tax={value_tax}
                    />
                }
            </div>
        </Dialog>
    )
}
